import $ from 'jquery';

class YoutubeController {
    constructor(index, elem) {
        this.index = index;
        this.elem = elem;

        // this.player = null;
        // this.youTubeClientId = null;

        this.initYoutubeEmbed();
    }

    initYoutubeEmbed() {
        let embedCode = this.elem.parentElement.dataset.embed;
        const thumbnail = (this.elem.className.search('4by3') > -1) ? '/sddefault.jpg' : '/maxresdefault.jpg';

        // strip code of query params
        const queryIndex = embedCode.indexOf('?');
        if (queryIndex > 0) embedCode = embedCode.substring(0, embedCode.indexOf('?'));

        const source = `https://img.youtube.com/vi/${embedCode}${thumbnail}`;

        const image = new Image();
        image.src = source;
        const loadElement = this.elem;
        image.addEventListener('load', (function () {
            loadElement.appendChild(image);
        }(this.index)));

        this.elem.addEventListener('click', function () {
            const iframe = document.createElement('iframe');

            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('src', `https://www.youtube.com/embed/${this.parentElement.dataset.embed}?rel=0&showinfo=0&autoplay=1&enablejsapi=1`);

            this.innerHTML = '';
            this.appendChild(iframe);
        });
    }


    static init() {
        $(document).ready(() => {
            $('.youtube').each((index, elem) => {
                new YoutubeController(index, elem); // eslint-disable-line no-new
            });
        });
    }
}

window.YoutubeController = YoutubeController;
export default YoutubeController;
